import * as core from '../../../../../../../core'
import * as rpNymc from '../rp-nymc'

export const RESOURCE = {
  payload: {
    alias: 'overview',
    appAlias: rpNymc.RESOURCE.payload.alias,
    description: 'A good place to get started',
    display: {
      isMain: true,
      position: 0,
    },
    name: 'Overview',
    page: { alias: 'rp:overview' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
